// extracted by mini-css-extract-plugin
export default {"gradient":"CCFooter_gradient__Es7gD","cc-footer":"CCFooter_cc-footer__mphEF","qLink":"CCFooter_qLink__I3EBk"};